import { PortalError } from './PortalError';

export class EmptyParametersError extends PortalError {
  constructor() {
    super('EmptyParametersError', `Not all parameters are provided`);
  }
}
